<template>
  <span>
    <template v-if="modo=='new'||modo=='edit'||modo=='flow'">
      <picture-input
        :ref="`pictureInput${campo.cmp_coluna}`"
        @change="onChange"
        width="1200"
        height="600"
        margin="5"
        :crop="false"
        accept="image/*"
        size="10"
        @remove="onRemoved"
        :zIndex="0"
        :removable="true"
        :prefill="showvalue?(endpoint+`/admin/content/arquivo/${showvalue}`):''"
        buttonClass="v-btn  v-btn--small theme--light"
        removeButtonClass="v-btn  v-btn--small theme--light"
        :customStrings="{
        upload: '<h1>'+T('Não suportado!')+'</h1>',
        drag: T('Coloque uma foto aqui'),
      change: T('Alterar'), // Text only
      remove: T('Remover'), // Text only
      select: T('Selecionar uma Imagem'), // Text only        
       
      }"
      ></picture-input>

      <v-progress-circular v-if="loading==true" :size="20" :width="4" color="blue" indeterminate></v-progress-circular>
    </template>

    <template v-if="modo=='list' || modo=='view' || modo=='viewmode'">
      <v-dialog v-model="dialog" max-width="600">
        <v-card style="position:relative;">
          <v-btn style="position:absolute;z-index:1;right:0px;" @click="dialog=false;" icon>
            <v-icon>close</v-icon>
          </v-btn>
          <img :src="endpoint+`/admin/content/arquivo/${value}`" />
        </v-card>
      </v-dialog>

      <v-avatar
        v-if="value"
        tile
        size="60"
        color="grey lighten-4 ma-1"
        @click="dialog=!dialog"
        style="cursor:pointer;"
      >
        <img :src="endpoint+`/admin/content/arquivo/${value}`" />
      </v-avatar>
    </template>

    <template v-if="modo=='filtro'">
      <v-text-field
        height="20"
        class="ma-0 pa-1"
        hide-details
        v-bind:value="preLoadFiltro(value)"
        v-on:input="(event)=>$emit('input', preUpdateFiltro(event))"
      ></v-text-field>
    </template>
  </span>
</template>
    

<script>
try{
  var _baseComponent = require("@/lib/componente/_base.vue").default;
}catch(err){
  var _baseComponent = require("@/framework/lib/componente/_base.vue").default;
}

import PictureInput from "vue-picture-input";

import axios from "axios";

export default {
  extends: _baseComponent,
  data() {
    return {
      dialog: false,
      loading: false,
      show: false,
      intravalue: this.value,
      width: this.getComponentParam("width") || 200,
      height: this.getComponentParam("height") || 200,
      format: this.getComponentParam("format") || "png",
      endpoint: global.config.endpoint,

      params: {},
      headers: {},
      imgDataUrl: null, // the datebase64 url of created image
    };
  },
  components: {
    PictureInput,
  },
  computed: {
    showvalue() {
      if (this.value == null) return null;

      return this.value.split("\n")[0];
    },
  },

  methods: {
    onChange(image) {
      console.log("New picture selected!");
      this.loading = true;

      if (image) {
        let that = this.$refs[`pictureInput${this.campo.cmp_coluna}`];
        console.log(that);
        let fd = new FormData();
        fd.append("file", that.file);

        axios
          .post(global.config.endpoint + `/admin/upload/foto/upload`, fd)
          .then(
            (resp) => {
              console.log("Picture loaded.", resp);
              this.loading = false;

              this.intravalue = resp.data.data.file;
            },
            (err) => {
              window.alert("Erro no upload!");
              that.removeImage();
              this.loading = false;
            }
          );
      } else {
        console.log("FileReader API not supported: use the <form>, Luke!");
      }
    },

    toggleShow() {
      this.show = !this.show;
    },
    onRemoved() {
      this.intravalue = null;
    },
  },

  watch: {
    intravalue(val) {
      this.$emit("input", this.preUpdate(val));
    },
  },
};
</script>

<style >
.picture-inner-text {
  font-size: 13px !important;
}
</style>

    